import { initBridge } from "@repo/bridge";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { bootstrap } from "./bootstrap";
import { config } from "./config";
import "./style.css";

// Detect the host carrier and run the single startup flow. The carrier is detected from host
// globals / iframe embedding; in standalone dev the bridge degrades to a no-host noop.
const { events } = initBridge();

// Bootstrap resolves with the cred manager (degrading gracefully to standalone when no host is
// present), which the app threads into the agent transport for authenticated requests.
bootstrap({ events, spaVersion: config.appVersion })
  .then(({ creds, hostContext, host }) => {
    createRoot(document.getElementById("app")!).render(
      <App
        creds={creds}
        hostContext={hostContext}
        host={host}
        onClose={() => events.close("user")}
      />,
    );
  })
  .catch((err) => {
    console.error("[tiger-agent] host bootstrap failed", err);
  });
